import React from 'react'

import { Grid, TextField, Button, Paper, Box, Typography, CircularProgress } from '@material-ui/core'
import { useMutation } from '@apollo/react-hooks'
import { UPDATE_PASSWORD } from './queries'
import { useStyles } from './styles'
import { toast } from 'react-toastify'
import { useHistory, Link } from 'react-router-dom'
import FooterLogos from  '../../components/FooterLogos'
import { validatePassword } from '../../utils/functions'

function RecoveryPage() {
  const history = useHistory()
  let recoveryToken = null

  const urlToken = new URL(window.location.href).searchParams.get('token')
  !!urlToken
    ? recoveryToken = urlToken
    : history.push('/login')

  const classes = useStyles()
  const [newPassword, setNewPassword] = React.useState('')
  const [newPasswordConfirmation, setNewPasswordConfirmation] = React.useState('')
  const [updatePassword, { loading: updatingPassword, error }] = useMutation(UPDATE_PASSWORD)

  React.useEffect(() => {
    if(error) {
      toast.error(error.message.split(':')[1])
    }
  }, [error])

  const handleUpdatePassword = () => {
    const variables = {
      newPassword,
      recoveryToken,
    }

    updatePassword({
      variables,
      update(cache, { data: { updatePassword }}) {
        localStorage.setItem('token', updatePassword.token)
        history.replace('/admin')
      }
    })
  }

  const passwordMessage = validatePassword(newPassword, newPasswordConfirmation)

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: '100%' }}
    >
      <Grid item xs={ 10 } md={ 5 }>
        <Paper elevation={ 1 } className={ classes.wrapper }>
          <Grid
            container
            justify="center"
            alignItems="center"
          >

            <Grid item xs={ 10 } className={ classes.title }>
              <Box mt={ 2 }>
                <Typography variant="h2" noWrap><b>ISE</b>B3</Typography>
              </Box>
              <Box mt={ 1 }>
                <Typography variant="p" className={ classes.subtitle }>
                  Digite aqui a sua nova senha
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={ 10 } className={ classes.field }>
              <TextField
                autoFocus
                fullWidth
                value={ newPassword }
                onChange={ event => setNewPassword(event.target.value) }
                type="password"
                placeholder="Digite a sua nova senha"
              />
            </Grid>
            <Grid item xs={ 10 } className={ classes.field }>
              <TextField
                fullWidth
                placeholder="Confirme a sua nova senha"
                type="password"
                value={ newPasswordConfirmation }
                onChange={ event => setNewPasswordConfirmation(event.target.value) }
              />
            </Grid>
            <Grid
              item
              xs={ 10 }
              className={ classes.newPasswordInvalidMessage }
            >
              <Typography align="center">
                { passwordMessage }
              </Typography>
            </Grid>
            <Grid
              item
              xs={ 8 }
              md={ newPassword === newPasswordConfirmation ? 6 : 10 }
              className={ classes.submit }
            >
              <Button
                fullWidth
                onClick={ handleUpdatePassword }
                disabled={
                  !newPassword ||
                  !newPasswordConfirmation ||
                  newPassword !== newPasswordConfirmation ||
                  !!passwordMessage
                }
              >
                {
                  updatingPassword
                    ? <CircularProgress size={ 25 } />
                    : 'Atualizar Senha'
                }
              </Button>
            </Grid>

            <Grid item xs={ 10 } className={ classes.loginLinkWrapper }>
              <Link to="/login" className={ classes.loginLink }>
                Clique aqui para fazer o login
              </Link>
            </Grid>
          </Grid>

          {/* <FooterLogos /> */}
        </Paper>
      </Grid>
    </Grid>
  )
}

export default RecoveryPage
